import { Modal, registerNavigationHandlers } from '@bonanza-social/navigation';

const MODALS_MAP = {
  '/terms': 'TermsScreenModal',
  '/privacy': 'PrivacyModal',
} as const;

registerNavigationHandlers<AppNavigatorParamsList, 'MiscScreen'>({
  MiscScreen(navigate, params) {
    const { path = '/', openInModal = false } = params || {};

    if (openInModal && path in MODALS_MAP) {
      Modal.open({
        namespace: 'web',
        type: MODALS_MAP[path as keyof typeof MODALS_MAP],
      });
    } else {
      navigate(path);
    }
  },
});

registerNavigationHandlers({
  Home(navigate) {
    navigate('/');
  },
  Games(navigate) {
    navigate('/games');
  },
  Account(navigate) {
    // Account routes are disabled in Router; keep original target
    navigate('/account');
  },
});
